export default __webpack_public_path__ + "static/mob-cloud-b71521306a1fa55f7f4c3a50bc18c612.png";